import { getClientLanguage } from '@/lib/get-client-language';

export const percentageFormatter = new Intl.NumberFormat(getClientLanguage(), {
  style: 'percent',
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
